export default "__VITE_ASSET__CVEnjCPY__"